<template>
  <div>
    <v-btn color="appMain" @click="modalOpen = true" :disabled="disabled">
      Edit
    </v-btn>

    <v-dialog
      v-model="modalOpen"
      max-width="500px"
      content-class="fixed-height-md"
    >
      <modal-card
        title="Change Campaign Start Date"
        fixed
        padding
        @close="modalOpen = false"
      >
        <v-alert type="info" class="mb-4">
          Warning! This could effect when your triggers are sent if you have
          some setup already.
        </v-alert>
        <v-menu
          ref="datePicker"
          :close-on-content-click="false"
          v-model="datePickerModal"
          :nudge-right="40"
          transition="scale-transition"
          min-width="290px"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-text-field
                slot="activator"
                v-model="date"
                readonly
                label="Start Date"
                hint=""
                persistent-hint
                append-icon="today"
              />
            </div>
          </template>
          <v-date-picker
            v-model="date"
            color="primary"
            no-title
            @input="datePickerModal = false"
          />
        </v-menu>

        <template v-slot:actions>
          <v-btn color="appMain" @click="saveDate" :disabled="disabled"
            >Save</v-btn
          >
        </template>
      </modal-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'CampaignContentDateModal',
  props: {
    campaign: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      date: '',
      datePickerModal: false,
      modalOpen: false,
    };
  },
  methods: {
    saveDate() {
      this.campaign.start_time = this.date;
      this.modalOpen = false;
    },
  },
  mounted() {
    this.date = this.campaign.start_time;
  },
};
</script>
